export interface ExtendedUserInfoResponse {
  userFullName: string;
  userPositionTitle: string;
  userEmployeeID: string;
  userPhoneNumber: string;
  userLocation: string;
  userEmailAddress: string;
  userManagerName: string;
  userDepartment: string;
}
